export const MAGIC_EDEN_FEE = 0.02;
export const CREATOR_FEE_ROYALTY = 10000;
export const MAGICEDEN = "magiceden";
export const MAGIC_EDEN_WEBSITE_URL = "https://magiceden.io";
export const ITEM_DETAILS = "/item-details";
export const CREATE_ME_BUY_ACCOUNTS = 8;
export const CREATE_ME_SELL_ACCOUNTS = 11;
